"use strict";

var _regeneratorRuntime = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/illing/code/udacity/blockchain/alpacoin/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bn_js_1 = __importDefault(require("bn.js"));

var web3_eth_abi_1 = __importDefault(require("web3-eth-abi"));

var web3_utils_1 = __importStar(require("web3-utils"));

var tx_1 = require("@ethereumjs/tx");

var ethereumjs_util_1 = require("ethereumjs-util");

var chalk_1 = __importDefault(require("chalk"));

var rlp_1 = require("rlp");

var Environments_1 = require("./Environments");

function removeHexPrefix(hex) {
  if (hex == null || typeof hex.replace !== 'function') {
    throw new Error('Cannot remove hex prefix');
  }

  return hex.replace(/^0x/, '');
}

exports.removeHexPrefix = removeHexPrefix;
var zeroPad = '0000000000000000000000000000000000000000000000000000000000000000';

function padTo64(hex) {
  if (hex.length < 64) {
    hex = (zeroPad + hex).slice(-64);
  }

  return hex;
}

exports.padTo64 = padTo64;

function signatureRSV2Hex(r, s, v) {
  return '0x' + padTo64(r.toString('hex')) + padTo64(s.toString('hex')) + v.toString(16).padStart(2, '0');
}

exports.signatureRSV2Hex = signatureRSV2Hex;

function event2topic(contract, names) {
  // for testing: don't crash on mockup..
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  if (!contract.options || !contract.options.jsonInterface) {
    return names;
  }

  return contract.options.jsonInterface.filter(function (e) {
    return names.includes(e.name);
  }) // @ts-ignore
  .map(web3_eth_abi_1.default.encodeEventSignature);
}

exports.event2topic = event2topic;

function addresses2topics(addresses) {
  return addresses.map(address2topic);
}

exports.addresses2topics = addresses2topics;

function address2topic(address) {
  return '0x' + '0'.repeat(24) + address.toLowerCase().slice(2);
}

exports.address2topic = address2topic; // extract revert reason from a revert bytes array.

function decodeRevertReason(revertBytes) {
  var throwOnError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (revertBytes == null) {
    return null;
  }

  if (!revertBytes.startsWith('0x08c379a0')) {
    if (throwOnError) {
      throw new Error('invalid revert bytes: ' + revertBytes);
    }

    return revertBytes;
  } // @ts-ignore


  return web3_eth_abi_1.default.decodeParameter('string', '0x' + revertBytes.slice(10));
}

exports.decodeRevertReason = decodeRevertReason;

function getDefaultMethodSuffix(_x) {
  return _getDefaultMethodSuffix.apply(this, arguments);
}

function _getDefaultMethodSuffix() {
  _getDefaultMethodSuffix = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(web3) {
    var nodeInfo;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return web3.eth.getNodeInfo();

          case 2:
            nodeInfo = _context.sent;

            if (!nodeInfo.toLowerCase().includes('testrpc')) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", '');

          case 5:
            if (!nodeInfo.toLowerCase().includes('hardhat')) {
              _context.next = 7;
              break;
            }

            return _context.abrupt("return", '_v4');

          case 7:
            return _context.abrupt("return", '_v4');

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getDefaultMethodSuffix.apply(this, arguments);
}

exports.getDefaultMethodSuffix = getDefaultMethodSuffix;

function getEip712Signature(_x2, _x3) {
  return _getEip712Signature.apply(this, arguments);
}

function _getEip712Signature() {
  _getEip712Signature = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(web3, typedRequestData) {
    var methodSuffix,
        jsonStringifyRequest,
        senderAddress,
        dataToSign,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            methodSuffix = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : null;
            jsonStringifyRequest = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : false;
            senderAddress = typedRequestData.message.from;

            if (jsonStringifyRequest) {
              dataToSign = JSON.stringify(typedRequestData);
            } else {
              dataToSign = typedRequestData;
            }

            if (!(methodSuffix !== null && methodSuffix !== void 0)) {
              _context2.next = 8;
              break;
            }

            _context2.t0 = methodSuffix;
            _context2.next = 11;
            break;

          case 8:
            _context2.next = 10;
            return getDefaultMethodSuffix(web3);

          case 10:
            _context2.t0 = _context2.sent;

          case 11:
            methodSuffix = _context2.t0;
            _context2.next = 14;
            return new Promise(function (resolve, reject) {
              var method; // @ts-ignore (the entire web3 typing is fucked up)

              // @ts-ignore (the entire web3 typing is fucked up)
              if (typeof web3.currentProvider.sendAsync === 'function') {
                // @ts-ignore
                method = web3.currentProvider.sendAsync;
              } else {
                // @ts-ignore
                method = web3.currentProvider.send;
              }

              var paramBlock = {
                method: "eth_signTypedData".concat(methodSuffix),
                params: [senderAddress, dataToSign],
                jsonrpc: '2.0',
                id: Date.now()
              };
              method.bind(web3.currentProvider)(paramBlock, function (error, result) {
                var _a;

                if ((result === null || result === void 0 ? void 0 : result.error) != null) {
                  error = result.error;
                }

                if (error != null || result == null) {
                  reject((_a = error.message) !== null && _a !== void 0 ? _a : error);
                } else {
                  resolve(correctV(result.result));
                }
              });
            });

          case 14:
            return _context2.abrupt("return", _context2.sent);

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getEip712Signature.apply(this, arguments);
}

exports.getEip712Signature = getEip712Signature;

function correctV(result) {
  var buffer = ethereumjs_util_1.toBuffer(result);
  var last = buffer.length - 1;
  var oldV = buffer[last];

  if (oldV < 2) {
    buffer[last] += 27;
    console.warn("signature V adjusted from ".concat(oldV, " to ").concat(buffer[last]));
  }

  return ethereumjs_util_1.bufferToHex(buffer);
}
/**
 * @returns the actual cost of putting this transaction on chain.
 */


function calculateCalldataCost(calldata) {
  var calldataBuf = Buffer.from(calldata.replace('0x', ''), 'hex');
  var sum = 0;
  calldataBuf.forEach(function (ch) {
    sum += ch === 0 ? Environments_1.defaultEnvironment.gtxdatazero : Environments_1.defaultEnvironment.gtxdatanonzero;
  });
  return sum;
}

exports.calculateCalldataCost = calculateCalldataCost;
/**
 * @returns maximum possible gas consumption by this relayed call
 * (calculated on chain by RelayHub.verifyGasAndDataLimits)
 */

function calculateTransactionMaxPossibleGas(_ref) {
  var gasAndDataLimits = _ref.gasAndDataLimits,
      hubOverhead = _ref.hubOverhead,
      relayCallGasLimit = _ref.relayCallGasLimit,
      msgData = _ref.msgData,
      msgDataGasCostInsideTransaction = _ref.msgDataGasCostInsideTransaction;
  return hubOverhead + msgDataGasCostInsideTransaction + calculateCalldataCost(msgData) + parseInt(relayCallGasLimit) + parseInt(gasAndDataLimits.preRelayedCallGasLimit.toString()) + parseInt(gasAndDataLimits.postRelayedCallGasLimit.toString());
}

exports.calculateTransactionMaxPossibleGas = calculateTransactionMaxPossibleGas;

function getEcRecoverMeta(message, signature) {
  if (typeof signature === 'string') {
    var r = parseHexString(signature.substr(2, 65));
    var s = parseHexString(signature.substr(66, 65));
    var v = parseHexString(signature.substr(130, 2));
    signature = {
      v: v,
      r: r,
      s: s
    };
  }

  var msg = Buffer.concat([Buffer.from('\x19Ethereum Signed Message:\n32'), Buffer.from(removeHexPrefix(message), 'hex')]);
  var signed = web3_utils_1.default.sha3('0x' + msg.toString('hex'));

  if (signed == null) {
    throw new Error('web3Utils.sha3 failed somehow');
  }

  var bufSigned = Buffer.from(removeHexPrefix(signed), 'hex');
  var recoveredPubKey = ethereumjs_util_1.ecrecover(bufSigned, signature.v[0], Buffer.from(signature.r), Buffer.from(signature.s));
  return ethereumjs_util_1.bufferToHex(ethereumjs_util_1.pubToAddress(recoveredPubKey));
}

exports.getEcRecoverMeta = getEcRecoverMeta;

function parseHexString(str) {
  var result = [];

  while (str.length >= 2) {
    result.push(parseInt(str.substring(0, 2), 16));
    str = str.substring(2, str.length);
  }

  return result;
}

exports.parseHexString = parseHexString;

function isSameAddress(address1, address2) {
  return address1.toLowerCase() === address2.toLowerCase();
}

exports.isSameAddress = isSameAddress;

function sleep(_x4) {
  return _sleep.apply(this, arguments);
}

function _sleep() {
  _sleep = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(ms) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return new Promise(function (resolve) {
              return setTimeout(resolve, ms);
            });

          case 2:
            return _context3.abrupt("return", _context3.sent);

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _sleep.apply(this, arguments);
}

exports.sleep = sleep;

function ether(n) {
  return new bn_js_1.default(web3_utils_1.toWei(n, 'ether'));
}

exports.ether = ether;

function randomInRange(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}

exports.randomInRange = randomInRange;

function eventsComparator(a, b) {
  if (a.blockNumber === b.blockNumber) {
    return b.transactionIndex - a.transactionIndex;
  }

  return b.blockNumber - a.blockNumber;
}

exports.eventsComparator = eventsComparator;

function isSecondEventLater(a, b) {
  return eventsComparator(a, b) > 0;
}

exports.isSecondEventLater = isSecondEventLater;

function getLatestEventData(events) {
  if (events.length === 0) {
    return;
  }

  var eventDataSorted = events.sort(eventsComparator);
  return eventDataSorted[0];
}

exports.getLatestEventData = getLatestEventData;

function boolString(bool) {
  return bool ? chalk_1.default.green('good'.padEnd(14)) : chalk_1.default.red('wrong'.padEnd(14));
}

exports.boolString = boolString;

function getDataAndSignature(tx, chainId) {
  if (tx.to == null) {
    throw new Error('tx.to must be defined');
  }

  if (tx.s == null || tx.r == null || tx.v == null) {
    throw new Error('tx signature must be defined');
  }

  var input = [ethereumjs_util_1.bnToUnpaddedBuffer(tx.nonce), ethereumjs_util_1.bnToUnpaddedBuffer(tx.gasPrice), ethereumjs_util_1.bnToUnpaddedBuffer(tx.gasLimit), tx.to.toBuffer(), ethereumjs_util_1.bnToUnpaddedBuffer(tx.value), tx.data];
  input.push(ethereumjs_util_1.toBuffer(chainId), ethereumjs_util_1.unpadBuffer(ethereumjs_util_1.toBuffer(0)), ethereumjs_util_1.unpadBuffer(ethereumjs_util_1.toBuffer(0)));
  var vInt = tx.v.toNumber();

  if (vInt > 28) {
    vInt -= chainId * 2 + 8;
  }

  var data = "0x".concat(rlp_1.encode(input).toString('hex'));
  var signature = signatureRSV2Hex(tx.r, tx.s, vInt);
  return {
    data: data,
    signature: signature
  };
}

exports.getDataAndSignature = getDataAndSignature;

function signedTransactionToHash(signedTransaction, transactionOptions) {
  return ethereumjs_util_1.bufferToHex(tx_1.Transaction.fromSerializedTx(ethereumjs_util_1.toBuffer(signedTransaction), transactionOptions).hash());
}

exports.signedTransactionToHash = signedTransactionToHash;